module.exports = __webpack_public_path__ + "assets/form.5c2426c1.svg";